import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { LIST_PARAM, TAB_PARAM, VACANCY_FILTER_KEYS } from "../constants";
import type { VacancyFilterSection } from "../hooks/useVacancyFilterSections";

import {
  FiltersDrawer,
  type FiltersDrawerProps,
} from "@/components/ui/v2/filters/FiltersDrawer";
import { URL_PARAMS } from "@/constants/urlParams";

const PRESERVE_PARAM_KEYS = [
  TAB_PARAM,
  LIST_PARAM,
  URL_PARAMS.SEARCH,
  URL_PARAMS.DESCENDING,
];

type VacanciesFiltersDrawerProps = Pick<
  FiltersDrawerProps,
  "open" | "onOpenChange" | "searchTag" | "useFilteredCount" | "filtersLoading"
> & { filterSections: VacancyFilterSection[] };

export function VacanciesFiltersDrawer(props: VacanciesFiltersDrawerProps) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  return (
    <FiltersDrawer
      {...props}
      searchParams={searchParams}
      filterKeys={VACANCY_FILTER_KEYS}
      entityName={t("common.vacancies")}
      preserveParamKeys={PRESERVE_PARAM_KEYS}
      resetsPage={false}
    />
  );
}
